var _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFunnel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 678,
    height: 173,
    viewBox: "0 0 678 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1C80.1886 76.5676 621.375 63.4427 677 62.6473",
    stroke: "#22A8F3",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 172C80.1886 96.4324 621.375 109.557 677 110.353",
    stroke: "#22A8F3",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 47.5,
    r: 11.5,
    fill: "url(#paint0_radial)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.5,
    cy: 70.5,
    r: 11.5,
    fill: "url(#paint1_radial)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 247.5,
    cy: 95.5,
    r: 11.5,
    fill: "url(#paint2_radial)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 65.5,
    r: 8.5,
    fill: "url(#paint3_radial)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 99,
    r: 10,
    fill: "url(#paint4_radial)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 75,
    r: 8,
    fill: "url(#paint5_radial)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 83,
    r: 6,
    fill: "url(#paint6_radial)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 53,
    r: 6,
    fill: "url(#paint7_radial)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 98.5,
    r: 9.5,
    fill: "url(#paint8_radial)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 122.5,
    r: 8.5,
    fill: "url(#paint9_radial)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 102,
    r: 9,
    fill: "url(#paint10_radial)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 163,
    cy: 86,
    r: 6,
    fill: "url(#paint11_radial)"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 175.5,
    cy: 98.5,
    r: 8.5,
    fill: "url(#paint12_radial)"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 102,
    r: 8,
    fill: "url(#paint13_radial)"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 324.5,
    cy: 74.5,
    r: 9.5,
    fill: "url(#paint14_radial)"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.5,
    cy: 90.5,
    r: 6.5,
    fill: "url(#paint15_radial)"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 352.5,
    cy: 91.5,
    r: 6.5,
    fill: "url(#paint16_radial)"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 435.5,
    cy: 81.5,
    r: 10.5,
    fill: "url(#paint17_radial)"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 431.5,
    cy: 94.5,
    r: 6.5,
    fill: "url(#paint18_radial)"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 451.5,
    cy: 94.5,
    r: 6.5,
    fill: "url(#paint19_radial)"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 459.5,
    cy: 81.5,
    r: 6.5,
    fill: "url(#paint20_radial)"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 479.5,
    cy: 81.5,
    r: 6.5,
    fill: "url(#paint21_radial)"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 520.5,
    cy: 92.5,
    r: 6.5,
    fill: "url(#paint22_radial)"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 516,
    cy: 77,
    r: 9,
    fill: "url(#paint23_radial)"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 533.5,
    cy: 82.5,
    r: 6.5,
    fill: "url(#paint24_radial)"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 566,
    cy: 81,
    r: 9,
    fill: "url(#paint25_radial)"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 644.5,
    cy: 93.5,
    r: 6.5,
    fill: "url(#paint26_radial)"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 664.5,
    cy: 87.5,
    r: 6.5,
    fill: "url(#paint27_radial)"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 617.5,
    cy: 82.5,
    r: 10.5,
    fill: "url(#paint28_radial)"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 592,
    cy: 93,
    r: 11,
    fill: "url(#paint29_radial)"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 482.5,
    cy: 95.5,
    r: 6.5,
    fill: "url(#paint30_radial)"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 494.5,
    cy: 87.5,
    r: 6.5,
    fill: "url(#paint31_radial)"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 504.5,
    cy: 93.5,
    r: 6.5,
    fill: "url(#paint32_radial)"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 370.5,
    cy: 86.5,
    r: 6.5,
    fill: "url(#paint33_radial)"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 203,
    cy: 86,
    r: 6,
    fill: "url(#paint34_radial)"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 218,
    cy: 101,
    r: 6,
    fill: "url(#paint35_radial)"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 223,
    cy: 106,
    r: 6,
    fill: "url(#paint36_radial)"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 377.5,
    cy: 93.5,
    r: 6.5,
    fill: "url(#paint37_radial)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.5 47.5) rotate(90) scale(11.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ECD63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ECD63",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(184.5 70.5) rotate(90) scale(11.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ECD63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ECD63",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(247.5 95.5) rotate(90) scale(11.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ECD63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ECD63",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.5 65.5) rotate(90) scale(8.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F07556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F07556",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46 99) rotate(90) scale(10)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ECD63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ECD63",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84 75) rotate(90) scale(8)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ECD63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ECD63",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 83) rotate(90) scale(6)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22A8F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22A8F3",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(88 53) rotate(90) scale(6)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22A8F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22A8F3",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.5 98.5) rotate(90) scale(9.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F07556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F07556",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.5 122.5) rotate(90) scale(8.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22A8F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22A8F3",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108 102) rotate(90) scale(9)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22A8F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22A8F3",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(163 86) rotate(90) scale(6)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22A8F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22A8F3",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(175.5 98.5) rotate(90) scale(8.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ECD63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ECD63",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(310 102) rotate(90) scale(8)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ECD63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ECD63",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(324.5 74.5) rotate(90) scale(9.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22A8F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22A8F3",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(333.5 90.5) rotate(90) scale(6.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ECD63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ECD63",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(352.5 91.5) rotate(90) scale(6.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ECD63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ECD63",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(435.5 81.5) rotate(90) scale(10.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22A8F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22A8F3",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(431.5 94.5) rotate(90) scale(6.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F07556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F07556",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(451.5 94.5) rotate(90) scale(6.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22A8F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22A8F3",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(459.5 81.5) rotate(90) scale(6.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22A8F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22A8F3",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(479.5 81.5) rotate(90) scale(6.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ECD63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ECD63",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(520.5 92.5) rotate(90) scale(6.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ECD63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ECD63",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(516 77) rotate(90) scale(9)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22A8F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22A8F3",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(533.5 82.5) rotate(90) scale(6.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F07556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F07556",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(566 81) rotate(90) scale(9)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22A8F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22A8F3",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(644.5 93.5) rotate(90) scale(6.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ECD63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ECD63",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(664.5 87.5) rotate(90) scale(6.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F07556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F07556",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(617.5 82.5) rotate(90) scale(10.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22A8F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22A8F3",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(592 93) rotate(90) scale(11)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ECD63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ECD63",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(482.5 95.5) rotate(90) scale(6.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ECD63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ECD63",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(494.5 87.5) rotate(90) scale(6.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22A8F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22A8F3",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(504.5 93.5) rotate(90) scale(6.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F07556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F07556",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(370.5 86.5) rotate(90) scale(6.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22A8F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22A8F3",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(203 86) rotate(90) scale(6)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22A8F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22A8F3",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(218 101) rotate(90) scale(6)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22A8F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22A8F3",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(223 106) rotate(90) scale(6)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F07556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F07556",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(377.5 93.5) rotate(90) scale(6.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F07556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F07556",
    stopOpacity: 0.38
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnel);
export default __webpack_public_path__ + "static/media/funnel.40003078c684a4a723bfef53bdd93b33.svg";
export { ForwardRef as ReactComponent };